export const positionReducer = (state, action) => {
  switch (action.type) {
    case "loadPosition":
      console.log("loading position");
      return loadPosition(state, action.positions);
    case "addPosition":
      console.log("adding position");
      return addPosition(state, action.position);
    case "editPosition":
      console.log("editing position");
      return editPosition(state, action.position);
    default:
      return state;
  }
};

const loadPosition = (state, positions) => {
  let newState = [...positions];

  return newState;
};
const addPosition = (state, position) => {
  let newState = [
    ...state,
    { id: parseInt(state[state.length - 1].id) + 1, ...position },
  ];

  return newState;
};

const editPosition = (state, position) => {
  let newState = state.map((elem) => {
    if (elem.id == position.id) {
      return { ...position };
    }
    return elem;
  });

  return newState;
};
